import React from "react";
import Dashboard from  "../modules/Dashboard/Dashboard";

export default function DashboardPage() {
  return <Dashboard />;
}
